import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface AllAgentState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
}

const initialState: AllAgentState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
};

export const allAgentMasterSlice = createSlice({
  name: 'agentMaster',
  initialState,
  reducers: {
    setAgentMaster: (state, action) => {
      state.data = action.payload.data.content;
      state.totalRecords = action.payload.data.totalElements;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.number;
    },
    setAgentMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAgentMaster,setAgentMasterBySearch, reset } = allAgentMasterSlice.actions;
export const getAgentMasterDetails = (state: RootState) => state.agentMaster.data;
export const getAgentMasterDetailsBySearch = (state: RootState) => state.agentMaster.data;
export const getAgentMasterTotalRecords = (state:RootState)=>state.agentMaster.totalRecords;
export default allAgentMasterSlice.reducer;